import { SITE, channels, navLinks } from "@/mocks/site";

const social = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-primary-900 text-background-200">
      <div className="pointer-events-none absolute -left-16 -top-24 h-64 w-64 rounded-full bg-primary-600/30 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-24 right-0 h-64 w-72 rounded-full bg-accent-500/20 blur-3xl"></div>

      <div className="relative mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-12">
          {/* brand */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5" aria-label="返回首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className="ri-radar-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="leading-none">
                <span className="block font-heading text-xl font-black text-background-50">
                  {SITE.brand}
                  <span className="ml-1.5 align-middle font-label text-[10px] font-bold uppercase tracking-[0.3em] text-accent-300">
                    {SITE.brandEn}
                  </span>
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              {SITE.slogan}。专注八卦爆料与圈内资源情报，覆盖未官宣行程、资源瓜、新戏饼、综艺邀约、商务代言与空降活动。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {social.map((s) => (
                <a
                  key={s.label}
                  href="#subscribe"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:bg-background-50 hover:text-primary-600"
                >
                  <i className={`${s.icon} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* nav */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-200/80 transition-colors hover:text-accent-200">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* channels */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-bold text-background-50">追踪栏目</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {channels.map((c) => (
                <li key={c.key}>
                  <a href="#latest" className="flex items-center gap-1.5 text-sm text-background-200/80 transition-colors hover:text-accent-200">
                    <i className={`${c.icon} text-accent-300`} aria-hidden="true"></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold text-background-50">保持联系</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li>
                <a href={`mailto:${SITE.contactEmail}`} className="flex items-center gap-1.5 transition-colors hover:text-accent-200">
                  <i className="ri-mail-line text-accent-300" aria-hidden="true"></i>
                  投稿爆料
                </a>
              </li>
              <li>
                <a href="#subscribe" className="flex items-center gap-1.5 transition-colors hover:text-accent-200">
                  <i className="ri-mail-send-line text-accent-300" aria-hidden="true"></i>
                  订阅瓜报
                </a>
              </li>
              <li>
                <a href="#faq" className="flex items-center gap-1.5 transition-colors hover:text-accent-200">
                  <i className="ri-question-line text-accent-300" aria-hidden="true"></i>
                  吃瓜指南
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-200/60">
            © 2026 {SITE.brand} 版权所有 · 站内未官宣内容仅供参考，请理性看待。
          </p>
          <p className="flex items-center gap-1.5 whitespace-nowrap text-xs text-background-200/60">
            <i className="ri-shield-check-line text-accent-300" aria-hidden="true"></i>
            内容按“可信分级”呈现，谨慎传播
          </p>
        </div>
      </div>
    </footer>
  );
}